import React, { useState, useEffect } from 'react';
import "../../styles/department/main.css";
import { Link } from 'react-router-dom';
import { getAllDepartment } from '../../Services/AllAPIs';
import LoadingSpinner from '../LoadingSpinner';

const Main = () => {
    const [loader, setLoader] = useState(true);
    const [departments, setDepartments] = useState([]);
    const [error, setError] = useState(null);

    const getDepartments = () => {
        getAllDepartment()
            .then((res) => {
                setDepartments(res.data.departments);
                setLoader(false);
            })
            .catch((error) => {
                setError("An error occurred while fetching department data.");
                setLoader(false);
            });
    };

    useEffect(() => {
        getDepartments();
    }, []);

    return (
        <div className="departments-main pt-5">
            <div className="py-4">
                <div className="container">
                    <h2 className="my-heading">Departments</h2>

                    {loader && <LoadingSpinner />}

                    {error && <div className="error">{error}</div>}

                    <div className="main-card">
                        {departments.length > 0 ? (
                            departments.map((department) => {
                                // Determine the link for the department
                                const link = department.website
                                    ? department.website
                                    : `/faculty/${department.faculty_url_id}/department/${department.url_id}`;

                                return (
                                    <Link to={link} key={department.name}>
                                        <div className="card">
                                            <img
                                                className="normal"
                                                src={`../assets/images/it-department.png`}
                                                alt={department.name}
                                                style={{ height: 50, width: 50 }}
                                            />
                                            <img
                                                className="white"
                                                src={`../assets/images/it-department-white.png`}
                                                alt={department.name}
                                                style={{ height: 50, width: 50 }}
                                            />
                                            <h6 className="card-title">
                                                <p>{department.name}</p>
                                            </h6>
                                        </div>
                                    </Link>
                                );
                            })
                        ) : (
                            <div>No departments available.</div>
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Main;
